<template>
  <section class='cool-picker' id="areaPicker">
  </section>
</template>

<script>
import Util from '@/utils/util'
import MobileSelect from 'mobile-select'
// areas data
import PROVINCES from '../assets/json/provinces'
import CITIES from '../assets/json/cities'
import AREAS from '../assets/json/areas'

let customData = {
  key: ''
}

export default {
  name: 'areaPicker',
  components: {},
  data() {
    return {
      pickerShow: false
    }
  },
  computed: {},
  methods: {
    confirm(index, data) {
      let value = ''
      data.forEach((v, i) => {
        value += Util.htmlDecodeByRegExp(v) + ' '
      })
      value.trim()
      this.$emit('confirmAreaPicker', {
        key: customData.key,
        value: value,
        valArr: data,
        index: index
      })
    }
  },
  mounted() {
    let self = this
    let mobileSelect = new MobileSelect({
      trigger: '#areaPicker',
      triggerDisplayData: false,
      title: '',
      wheels: [
        {data: PROVINCES},
        {data: CITIES[0]},
        {data: AREAS[0][0]}
      ],
      callback(index, data) {
        console.log('area picker callback ', index, data)
        self.confirm(index, data)
      },
      transitionEnd(index, data) {
        // console.log('transitionEnd', index, data, CITIES[index[0]][index[1]])
        // console.log(AREAS[index[0]], AREAS[index[0]][index[1]])
        mobileSelect.locatePosition(0, index[0])
        let a1 = CITIES[index[0]][index[1]] ? index[1] : 0
        mobileSelect.updateWheel(1, CITIES[index[0]])
        mobileSelect.locatePosition(1, a1)
        let b1 = AREAS[index[0]] ? index[0] : 0
        let b2 = AREAS[index[0]][index[1]] ? index[1] : 0
        let b3 = AREAS[b1][b2][index[2]] ? index[2] : 0
        mobileSelect.updateWheel(2, AREAS[b1][b2])
        mobileSelect.locatePosition(2, b3)
      },
      // position: [2] // Initialize positioning
      cancel(index, data) {},
      // onShow() {},
      onHide() {
        self.pickerShow = false
        self.$emit('pickerHide')
      },
      maskOpacity: 0.4
    });
    this.$on('showAreaPicker', picker => {
      if (this.pickerShow) return
      customData.key = picker.key
      for (let i = 0; i < 3; i++) {
        mobileSelect.locatePosition(i, picker.index[i] || 0)
      }
      mobileSelect.updateWheel(1, CITIES[picker.index[0]])
      mobileSelect.updateWheel(2, AREAS[picker.index[0]][picker.index[1]])
      mobileSelect.show()
      this.pickerShow = true
    })
  },
  created() {
  }
}
</script>

<style scoped lang='scss'>

</style>
